/**
 * 初始化并存储供全局消费的公用api信息
 */
import { isNode } from 'src/utils/micro-utils';
import globalStore from 'src/utils/global-data-store';

export default function(globalData) {
  if (isNode()) return;
  transactionOverview(globalData);
  recommendProducts(globalData);
  getSupplierData(globalData);
}

function transactionOverview(globalData) {
  const { product, global } = globalData;
  const { productId } = product;
  const { language } = global;
  const url = `/event/app/productExportOrderQuery/transactionOverview.htm?detailId=${productId}&languageType=${language ||
    ''}`;
  const fetchPromise = fetch(url).then(res => res.json());
  globalStore.set('transactionOverview', fetchPromise);
}

function recommendProducts(globalData) {
  const { product, global } = globalData;
  const { productId } = product;
  const { language } = global;
  const url = `/event/app/detailRecommendProducts/recommend.htm?detailId=${productId}&language=${language}&version=VB`;
  const fetchPromise = fetch(url).then(res => res.json());
  globalStore.set('recommendProducts', fetchPromise);
}

function getSupplierData(globalData) {
  const { product } = globalData;
  const { productId } = product;
  if (!productId) return;

  const url = `/event/app/companyCardIntegrated/getSupplierData.htm?detailId=${productId}`;
  const fetchPromise = fetch(url).then(res => res.json());
  globalStore.set('supplierData', fetchPromise);
}
